export class WebhookV1StandardPayloadClassificationJobFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classificationJobFailed",
            "baseName": "classificationJobFailed",
            "type": "WebhookV1ClassificationJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadClassificationJobFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
